export enum UpdatePolicy {
    OVERWRITE = 'Overwrite',
    MERGE = 'Merge',
    KEEP_ORIGINAL = 'Keep Original'
}
